import { NgModule } from '@angular/core';
import { AddScorekeeperContentComponent } from './add-scorekeeper-content.component';

@NgModule({
  declarations: [],
  imports: [AddScorekeeperContentComponent],
  exports: [AddScorekeeperContentComponent]
})
export class AddScorekeeperContentModule { }
